module.exports = __webpack_public_path__ + "static/media/qr.840b25c4.svg";